import { render } from "./JokesList.vue?vue&type=template&id=69ea225a&scoped=true"
import script from "./JokesList.vue?vue&type=script&lang=js"
export * from "./JokesList.vue?vue&type=script&lang=js"

import "./JokesList.vue?vue&type=style&index=0&id=69ea225a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69ea225a"]])

export default __exports__